import React from 'react'

function AdmitCardRoutine(props) {
    return (
        <>
            {
                (props?.classValue && props?.assessmentSubjectValue) ?
                    (
                        <>
                                    <>
                                        <table className='table table-bordered ' border="2" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                            <thead className="">
                                                <tr>
                                                    <th style={{ padding: '8px', textAlign: 'left',color:"black",backgroundColor:'lightgray',fontSize:'8pt'  }}>
                                                        <div className='d-flex align-items-center justify-content-center w-100'>
                                                            Date
                                                        </div>
                                                    </th>
                                                    <th style={{ padding: '8px', textAlign: 'left',color:"black" ,backgroundColor:'lightgray',fontSize:'8pt' }}>
                                                        <div className='d-flex align-items-center justify-content-center w-100'>
                                                            Subjects
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props?.filtereduniqueDates?.map((date, index) => (
                                                    <tr key={index} className="font-weight-bold">
                                                        <td className="px-1 py-1" style={{ padding: '8px', textAlign: 'left',fontSize:'9pt'  }}>
                                                            <div className='mt-1 d-flex align-items-center justify-content-center'>
                                                                {date}
                                                            </div>
                                                        </td>
                                                        <td className="px-1 py-1" style={{ padding: '8px', textAlign: 'left',fontSize:'9pt'  }}>
                                                            <div className='d-flex flex-column align-items-center w-100'>
                                                                <span>
                                                                    {props?.filteredTable[date]?.join('/')}
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>

                        </>) :
                    (
                        <>
                            No records found.
                        </>)
            }
        </>
    )
}

export default AdmitCardRoutine